var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationLogs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M53.292 26.788V12.073a4.947 4.947 0 0 0-4.945-4.945h-31.28a4.947 4.947 0 0 0-4.945 4.945v42.141c0 2.722 2.2 4.932 4.921 4.945l4.024.019m1.275-41.101h20.212m-20.212 6.692h12.397m-12.397 6.946h5.657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M62.878 49.481c0-10.151-8.229-18.392-18.364-18.392S26.15 39.33 26.15 49.481s8.229 18.392 18.364 18.392c3.386 0 6.706-.937 9.593-2.709l8.771 2.709-2.705-8.784a18.4 18.4 0 0 0 2.705-9.607Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M35.766 46.24h17.496m-17.496 6.482h11.708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationLogs);
export default __webpack_public_path__ + "static/media/communication-logs.259897f6463e2bb6b3365ced7603ecb4.svg";
export { ForwardRef as ReactComponent };